import React from "react";
import "./Common_Title_2.css";

const Common_Title_2 = ({ title, subtitle, logo }) => {
  return (
    <>
      <div className="commontitle_2_div">
        <p className="maintitle">{title}</p>
        {subtitle && (
          <h5 className="subtitle">
            {subtitle} 
          </h5>
        )}
      </div>
    </>
  );
};

export default Common_Title_2;
